// extracted by mini-css-extract-plugin
export default {"Markdown":"index_Markdown__2RhVG typography_bodyFont__3RHTp"};